export class LocalStorageService {
  static setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static getItem(key: string) {
    try {
      const value = localStorage.getItem(key);
      return value && JSON.parse(value);
    } catch (e) {
      console.log(e);
    }
  }

  static clear(key: string) {
    localStorage.removeItem(key);
  }

  static clearAll() {
    const keepKeys = ['countdownStartTime'];
    Object.keys(localStorage).forEach((key) => {
      if (!keepKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  }
}
